export default "__VITE_ASSET__yD3q$I9L__"